import { savGroup } from "./savGroup";
import { assocGroup } from "./assocGroup";
import { clamGroup } from "./clamGroup";

// ** these all belong to the same portal id group layer but the different groups break it out further into menus.

export const inventoryGroup = {
  id: 'inventory',
  title: "Estuarine Inventory of New Jersey",
  type: 'group',
  items: [
    clamGroup,
    savGroup,
    assocGroup
  ],
};